module.exports = __webpack_public_path__ + "img/pxrv2.21590ce9.webp";